__turbopack_context__.v({
  "className": "nunito_8d670e11-module__NYxUcW__className",
});
